var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcJudge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.7871,
    y: 48.6943,
    width: 41.1386,
    height: 16.4555,
    transform: "rotate(-45.5529 62.7871 48.6943)",
    fill: "#3A7EFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.459,
    y: 48.7168,
    width: 6.58218,
    height: 19.7465,
    rx: 1,
    transform: "rotate(-45.5529 60.459 48.7168)",
    fill: "#87B1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.9609,
    y: 21.6992,
    width: 6.58218,
    height: 19.7465,
    rx: 1,
    transform: "rotate(-45.5529 86.9609 21.6992)",
    fill: "#87B1FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3555,
    y: 43.8604,
    width: 8.22773,
    height: 46.0753,
    rx: 2.5,
    transform: "rotate(-45.5529 81.3555 43.8604)",
    fill: "#3A7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5798 75.8909C43.6355 75.3839 44.0638 75 44.5739 75H75.3675C75.8776 75 76.3059 75.3839 76.3616 75.8909L77.349 84.8909C77.414 85.4828 76.9504 86 76.355 86H43.5864C42.991 86 42.5274 85.4828 42.5924 84.8909L43.5798 75.8909Z",
    fill: "#3A7EFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJudge);
export default __webpack_public_path__ + "static/media/IcJudge.759323f2b4030cdd2ea58534ac1e9cad.svg";
export { ForwardRef as ReactComponent };